
import {defineComponent, PropType} from "vue"
import ExcursionCard from "@/components/ExcursionCard.vue";
import {Excursion} from "@/services/excursions/types";
import ExcursionCardRect from "@/components/ExcursionCardRect.vue";

export default defineComponent({
  components: {
    ExcursionCardRect,
    ExcursionCard,
  },
  props: {
    excursions: {
      required: true,
      type: Object as PropType<Excursion[]>
    }
  },
  data: ()=>{
    return {
      paginate: 20
    }
  },
  computed: {
      filteredExcursions(){
        return this.excursions.slice(0,this.paginate).sort((a,b)=>{
          return a.price - b.price
        });
      },
      viewComponent() {
          if(window.innerWidth < 1000) {
            return ExcursionCardRect
          }
          return ExcursionCard
      },
  },
})
